import type { Shift } from "@src/appV2/Shifts/Shift/types";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format, parseISO } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { utcToZonedTime } from "date-fns-tz";

import { TimeSlot } from "../Shift/Open/types";

export type ShiftTimeSlotCount = Record<TimeSlot, number>;
export type ShiftsByDateAndTimeSlot = Record<string, ShiftTimeSlotCount>;

// Forked from @src/appV2/OpenShifts/utils/groupShiftsByDateAndPeriod
// but using TimeSlot instead of ShiftPeriod
export function groupShiftsByDateAndTimeSlot(
  shifts: Array<Pick<Shift, "facility" | "start" | "name">>, // TODO(ModalShiftData): use ModalShiftData or pick only relevant fields
  workerTimezone: string
): ShiftsByDateAndTimeSlot {
  const normalizedShifts: ShiftsByDateAndTimeSlot = {};

  for (const shift of shifts) {
    const shiftTimezone = shift.facility?.tmz ?? workerTimezone;
    const zonedDate = utcToZonedTime(parseISO(shift.start), shiftTimezone);
    const startDate = format(zonedDate, "yyyy-MM-dd");
    const shiftName = shift.name as unknown as TimeSlot;

    normalizedShifts[startDate] ||= {
      [TimeSlot.AM]: 0,
      [TimeSlot.PM]: 0,
      [TimeSlot.NOC]: 0,
    };

    normalizedShifts[startDate][shiftName] += 1;
  }

  return normalizedShifts;
}
